import { cn } from '@module/lib/utils';
import useChatPanelStore from '@module/stores/useChatPanelStore';
import React from 'react';

interface Props {
  children: React.ReactNode[];
}

export default function ChatItemContainer(props: Props) {
  const { children } = props;
  const pcFontSize = useChatPanelStore((state) => state.pcFontSize);

  const fontSizeClass = cn({
    'text-[13px]': pcFontSize === 13,
    'text-[15px]': pcFontSize === 15,
    'text-[19px]': pcFontSize === 19,
  });

  return (
    <>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        // Do not pass props to React.Fragment
        if (child.type === React.Fragment) return child;
        return React.cloneElement(child as React.ReactElement<{ fontSizeClass: string }>, { fontSizeClass });
      })}
    </>
  );
}
